 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		18: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		18: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"29f134fdc39a9ad0fa315128194e3e9d868d58b1","1":"073e7019bfe6c5db7638a7ab37df5e3e413f7590","2":"fc23880543f6cb094d07d78bf80774a285a174f3","3":"5c1fdf80f393a3fe5dd932d8abe6f3b0f8819475","4":"f1351aff46fcc3d613f0f08bce45bf0577183d54","5":"11094b64fe0f73baf096c7d6382dea9feaba11f0","6":"44b36a618a83a35f55dabdf35df9056e50214a87","7":"252f366e","8":"9bb998ff","9":"component---src-templates-service-tsx","10":"95b64a6e","11":"e8d199736a7805b3f796a957102335063758cf7d","12":"styles","13":"be40554fa4a67aa92771f093f690769d03ae21b8","14":"3c00337a12ada6a161ec4c79ea03e9c31c4faffa","15":"74b743768d7224142612e67f8be2d772e20516a1","16":"component---src-pages-index-tsx","17":"component---src-pages-services-tsx","20":"456ebb50","22":"73c8bfe1","24":"component---src-pages-404-tsx","25":"component---src-pages-company-tsx","26":"component---src-pages-contact-tsx","27":"component---src-pages-employees-tsx","28":"component---src-pages-family-clinic-tsx","29":"component---src-pages-guidance-tsx","30":"component---src-pages-jobs-tsx","31":"component---src-pages-kela-services-tsx","32":"component---src-pages-privacy-tsx","33":"component---src-pages-psychotherapies-tsx","34":"component---src-pages-qa-tsx","35":"component---src-pages-therapy-visit-tsx","36":"component---src-pages-trainings-tsx","37":"component---src-templates-blog-tsx","38":"component---src-templates-blogs-tsx","39":"component---src-templates-current-tsx","40":"component---src-templates-training-tsx","41":"d19d7564","42":"e19d6005"}[chunkId]||chunkId) + "-" + {"0":"d7e420efb5aaf9fa34bd","1":"91f15ae56618083b2234","2":"005447b3d544675bad23","3":"c7e916982746e86561c0","4":"cdd66657e133c6147efd","5":"af09e204953993602a73","6":"11366241b5637cecb294","7":"31da2527daa6ea1899c4","8":"421063abcde4ba599640","9":"f4cf80e37a883dc8707a","10":"f0a88889f4d711871bae","11":"5624c179978346720a66","12":"31f023f48facb69035d3","13":"9a195b0d9e4c86847c52","14":"d040e852058205e35191","15":"89c20e1cbe1cb85e815e","16":"ed83daa8899ec1368567","17":"f70a62eb7fd9c995c31f","20":"7c55db873a4f924f32a8","22":"d5aa1c89bc5a46d07411","24":"7a70838ecbf3a71ea840","25":"8024d71d07680f4b8cb4","26":"ec48fd5ea123f0d3530a","27":"95bf054562e133c1556f","28":"fc3f24f37b6d16b17b9e","29":"bf5ba22d310b5921b0d8","30":"f35ed0644ed5e5454696","31":"e09dc89e4f80b1784d89","32":"d156aea78056658b51d2","33":"6cbefc1ce0f59efa2864","34":"ab1571261159a810f4ed","35":"2068b598ffa729710957","36":"816559a7babc43a8c6b1","37":"4f795c9b72ffe11c4443","38":"06c4a644713047f3afee","39":"d7fdc67b40e241281ecb","40":"5cdc14f0bc562434ed24","41":"d94eca21655f823c7395","42":"70f1a50dfa63aab0f2cd"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"12":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"29f134fdc39a9ad0fa315128194e3e9d868d58b1","1":"073e7019bfe6c5db7638a7ab37df5e3e413f7590","2":"fc23880543f6cb094d07d78bf80774a285a174f3","3":"5c1fdf80f393a3fe5dd932d8abe6f3b0f8819475","4":"f1351aff46fcc3d613f0f08bce45bf0577183d54","5":"11094b64fe0f73baf096c7d6382dea9feaba11f0","6":"44b36a618a83a35f55dabdf35df9056e50214a87","7":"252f366e","8":"9bb998ff","9":"component---src-templates-service-tsx","10":"95b64a6e","11":"e8d199736a7805b3f796a957102335063758cf7d","12":"styles","13":"be40554fa4a67aa92771f093f690769d03ae21b8","14":"3c00337a12ada6a161ec4c79ea03e9c31c4faffa","15":"74b743768d7224142612e67f8be2d772e20516a1","16":"component---src-pages-index-tsx","17":"component---src-pages-services-tsx","20":"456ebb50","22":"73c8bfe1","24":"component---src-pages-404-tsx","25":"component---src-pages-company-tsx","26":"component---src-pages-contact-tsx","27":"component---src-pages-employees-tsx","28":"component---src-pages-family-clinic-tsx","29":"component---src-pages-guidance-tsx","30":"component---src-pages-jobs-tsx","31":"component---src-pages-kela-services-tsx","32":"component---src-pages-privacy-tsx","33":"component---src-pages-psychotherapies-tsx","34":"component---src-pages-qa-tsx","35":"component---src-pages-therapy-visit-tsx","36":"component---src-pages-trainings-tsx","37":"component---src-templates-blog-tsx","38":"component---src-templates-blogs-tsx","39":"component---src-templates-current-tsx","40":"component---src-templates-training-tsx","41":"d19d7564","42":"e19d6005"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"82f874e02c07c92c4532","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
